// extracted by mini-css-extract-plugin
export default {"applyButton":"applyform_applyButton__Mgopu","finePrint":"applyform_finePrint__HB0j5"};